export const functionDefs = [
  {
    name: 'setHumidityThreshold',
    args: ['min', 'max'],
  },
  {
    name: 'setTemperatureThreshold',
    args: ['min', 'max'],
  },
  {
    name: 'setNightHumidityThreshold',
    args: ['min', 'max'],
  },
  {
    name: 'setNightTemperatureThreshold',
    args: ['min', 'max'],
  },
  {
    name: 'setCO2Threshold',
    args: ['min', 'max'],
  },
  {
    name: 'calibrateCO2ppm',
    args: ['ppm'],
  },
  {
    name: 'forceCalibrate',
    args: [],
  },
  {
    name: 'setDisplayInterval',
    args: ['minutes'],
  },
  {
    name: 'setServerInterval',
    args: ['minutes'],
  },
  { name: 'getConfig', args: [] },
  { name: 'saveConfig', args: [] },
  { name: 'loadConfig', args: [] },
  { name: 'pushNow', args: [] },
  { name: 'syncTimeNow', args: [] },
  { name: 'setTimezone', args: [{ key: 'timezone', type: 'text' }] },
  { name: 'setManualTime', args: [{ key: 'manualTimestamp', type: 'text' }] },
  { name: 'setSecret', args: [{ key: 'secret', type: 'text' }] },
  {
    name: 'factoryReset',
    args: [{ key: 'wipeEEPROM', enum: ['true', 'false'] }],
  },
  {
    name: 'toggleSocket',
    args: [
      { key: 'socket', enum: ['1', '2', '3', '4'] },
      { key: 'state', enum: ['on', 'off', 'auto'] },
    ],
  },
  {
    name: 'relaySelfTest',
    args: [{ key: 'cycles', type: 'number' }],
  },
  { name: 'softReset', args: [] },
  { name: 'getReadings', args: [] },
  {
    name: 'setVPDType',
    args: [{ key: 'type', enum: ['air', 'leaf', 'leaf+'] }],
  },
];
